exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".znYzv{-ms-flex-pack:justify;justify-content:space-between;padding:0 20px;background-color:rgba(0,0,0,.4)}._2_JJ_,.znYzv{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}._2_JJ_{width:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-pack:center;justify-content:center}._1avGK{width:100%;text-align:center;overflow:hidden}.pAPcg+._1avGK{margin-top:10px}.pAPcg{text-align:center;width:100%}._4WcOj{font-size:22px;color:#fff;white-space:normal;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-titleFont-decoration}._1A-PL{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:100%;margin-bottom:25px}._2EZIk{-ms-flex:1 1 100%;flex:1 1 100%;max-width:50%;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration}._1gMwO ._2EZIk{-ms-flex:0 1 auto;flex:0 1 auto;max-width:100%;min-width:calc(50% + 20px)}._2OqRg ._2EZIk:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px}._2OqRg ._2EZIk:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}.S8OO2{font-size:14px;color:#fff}._1JDgi{top:8px;left:8px}", ""]);

// exports
exports.locals = {
	"overlay": "znYzv",
	"main": "_2_JJ_",
	"play-container": "_1avGK",
	"playContainer": "_1avGK",
	"title": "pAPcg",
	"title-text": "_4WcOj",
	"titleText": "_4WcOj",
	"buttons": "_1A-PL",
	"bottom-button": "_2EZIk",
	"bottomButton": "_2EZIk",
	"single": "_1gMwO",
	"rounded": "_2OqRg",
	"soon-info": "S8OO2",
	"soonInfo": "S8OO2",
	"live-label": "_1JDgi",
	"liveLabel": "_1JDgi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/components/player-overlay/mobile/three-rows-widget/three-rows-widget.styl
// module id = 2813
// module chunks = mobile/mobile